import $ from "../libs/jquery-3.3.1.min.js"
import {BaseGameLimno} from "/js/app/base/BaseGameLimno";
import {AudioPlaylist} from '/js/app/base/AudioPlaylist.js'
import {gsap} from "../libs/gsap/all.js"
import {Howl} from "howler";
import nunjucks from "/js/libs/nunjucks.js"
import {KeepSpeakersAlive} from "./components/KeepSpeakersAlive";

const QUIZ_USER_INPUT = 1;
const QUIZ_FEEDBACK = 2;
const QUIZ_ANIMATING = 3;

// Constructor
export class Logbook extends BaseGameLimno {

  constructor(topicId = "") {

    // Super constructor
    super("data/logbook.json", "LIMNO/STATION" + topicId);
    this.screensaverDelay = 45;
    // this.screensaverDelay = 1000000;

    this.playlist = new AudioPlaylist();
    this.bassinSounds = [];

    this.currentTimeline = null;
    this.currentQuizTimeline = null;
    this.sound = null;

    this.currentQuizData = null;
    this.quizStatus = null;

    this.quizNunjuckTemplate = null;
    this.currentQuizComponentIndex = null;

    this.firstTimeToBassin = true;

    this.keepSpeakersAlive = new KeepSpeakersAlive()
  }

  // Load data JSON (with promise)
  loadData() {
    return super.loadData()
      .then(() => this.loadZoneData("data/logbook-zone1.json"))
      .then((data) => this.data.zones.push(data))
      .then(() => this.loadZoneData("data/logbook-zone2.json"))
      .then((data) => this.data.zones.push(data))
      .then(() => this.loadZoneData("data/logbook-zone3.json"))
      .then((data) => this.data.zones.push(data))
      .then(() => this.loadZoneData("data/logbook-zone4.json"))
      .then((data) => this.data.zones.push(data))
  };

  // Load data JSON (with promise)
  loadZoneData(zoneDataFile) {
    return new Promise((resolve, reject) => {
      $.ajax({
        dataType: "json",
        url: zoneDataFile,
        cache: false,
      }).done((data) => {
        resolve(data);
      }).fail(function () {
        alert("No data found. Please add the data file and restart the app.");
        reject();
      });
    });
  };

  // Init nunjucks
  initNunjucks() {
    return super.initNunjucks()
      .then(() => $.ajax("templates/logbook-quiz.twig.html"))
      .then((template) => this.quizNunjuckTemplate = nunjucks.compile(template, this.nunjuckEnv))
  }

  // Render twig style with nunjucks
  renderQuiz() {
    return new Promise((resolve, reject) => {
      const res = this.quizNunjuckTemplate.render({quizData: this.currentQuizData});
      $("#quiz").html(res)
      $("img").each(function (i, img) {
        if ($(img).data("src")) {
          $(img).attr("src", $(img).data("src"))
        }
      });
      this.applyTheme(this.currentVisitorData.records.WALLPAPER);
      resolve();
    });
  }

  // Render twig style with nunjucks
  renderBassin() {
    return new Promise((resolve, reject) => {
      const res = this.quizNunjuckTemplate.render({quizData: this.currentQuizData});
      $("#quiz").html(res)
      $("img").each(function (i, img) {
        if ($(img).data("src")) {
          $(img).attr("src", $(img).data("src"))
        }
      });
      this.applyTheme(this.currentVisitorData.records.WALLPAPER);
      resolve();
    });
  }

  // To be overridden in child games
  initGame() {

    super.initGame();

    this.avatar.setFloating(true)

    // if (inElectron()) {
    //   this.playAudioAmbiance()
    // } else {
    //   $(window).one('click', this.playAudioAmbiance());
    // }

    // Go to first screen
    // if (inElectron()) {
    // this.initScreenSaver();
    // this.goToScreen(1);
    // } else {
    // 	$("#first-click-interact").one(this.touchEvent, $.proxy(this.initScreenSaver, this));
    // 	this.goToScreen("first-click-interact");
    // }

    // setTimeout(() => {
    //   console.log("Dev mode on")
    //   const visitorData = JSON.parse(this.simulator.buildMessageFromInputs());
    //   visitorData[0].records.ST_LOGBOOK_01 = "FALSE"
    //   if (visitorData.length > 0) {
    //     this.currentVisitorData = visitorData[0];
    //     this.initVisitor().then(async () => {
    //
    //       this.updateVisitorProgressScreen(3);
    //       await this.selectZone(2);
    //       this.selectQuizComponent(this.currentQuizData.length - 1);
    //       this.goToScreen(3);
    //
    //       // this.goToScreen(2);
    //       // this.goToScreen(4);
    //       // this.selectZone(0);
    //     });
    //   }
    // }, 500);

  };

  // Init visitor preferences
  async initVisitor() {
    await super.initVisitor();
    this.updateVisitorProgressScreen(false);
    this.updateVisitorProgress();
  }

  // To be overridden in child games
  initScreen(screenId) {

    // Super constructor
    if (super.initScreen(screenId) == false) {
      return false;
    }

    switch (screenId) {
      case 1:
        this.keepSpeakersAlive.start()
        break;
      case 2:
        this.keepSpeakersAlive.stop()
        this.currentZoneIndex = null;
        this.currentQuizComponentIndex = 0;
        $("#logbook-page-2").toggleClass("first-time-to-bassin", this.firstTimeToBassin)
        $("#logbook-page-2").toggleClass("completed-bassin", this.visitorHasCompletedItAll())
        this.animateScreen2();
        break;
      case 3:
        this.keepSpeakersAlive.stop()
        this.animateScreen3();
        break;
      case 4:
        this.keepSpeakersAlive.stop()
        this.animateScreen4();
        break;
      case 5:
        this.keepSpeakersAlive.stop()
        this.animateScreen5();
        break;
    }
  }

  // To be overridden in child games
  onMessage(e) {
    const type = e.type;
    const visitorData = e.visitorData;
    console.log("message received : ", type, visitorData);


    this.resetTimer();

    if (this.stillThereTimeout != false) {
      this.closeStillThereModal();
      // this.initScreenAudio(this.currentScreen);
      return;
    }

    // In all time, reset on tag remove
    if (type === "tagRemove") {
      this.reset(1);
    }

    // On screen 1, load data on tag drop
    if (this.currentScreen === 1 && type === "tagDrop") {
      if (this.currentVisitorHasCompletedRegistration()) {
        // Todo Define langugage from User profile
        this.initVisitor().then(() => {
          if (this.visitorHasAvailableActivities()) {
            this.goToScreen(2);
          }
          if (this.visitorHasCompletedItAll()) {
            this.goToScreen(5);
          } else {
            this.goToScreen(2);
          }
        });
      } else {
        console.log("Visitor has not completed registration, ignoring scan.");
      }
    }
  }

  animateScreen1() {

    // Stop current sounds
    this.stopCurrentNarration();

    // Build animation timeline
    this.currentTimeline = gsap.timeline();
    this.currentTimeline.to($(`#logbook-page-1, #logbook-page-2`), {
      rotation: 0,
      duration: 0.5,
      transformOrigin: "98px 98px"
    });
    this.currentTimeline.to($(`#logbook`), {
      x: 0,
      duration: 0.5,
    }, '<');
    this.currentTimeline.fromTo($(`#intro-wrapper, .rfid-cta`, `#screen-1`), {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
      duration: 1,
    });
  }

  animateScreen2() {

    // Stop current sounds
    this.stopCurrentNarration();

    // Build animation timeline
    this.currentTimeline = gsap.timeline();
    this.currentTimeline.to($(`#logbook-page-1`), {
      rotation: 85,
      duration: 1,
      transformOrigin: "98px 98px"
    });
    this.currentTimeline.to($(`#logbook-page-2`), {
      rotation: 0,
      duration: 1,
      transformOrigin: "98px 98px"
    }, '<');
    this.currentTimeline.to($(`#logbook`), {
      x: -62,
      duration: 1,
    }, '<');

    this.currentTimeline.to($(`#avatar`), {
      x: 0,
      autoAlpha: 1,
      duration: 1,
    });

    if ($(`#screen-2 .quit-button`).length > 0) {
      this.currentTimeline.fromTo($(`#screen-2 .quit-button`), {
        autoAlpha: 0,
      }, {
        autoAlpha: 1,
        duration: 0.5,
      }, "-=0.5");
    }

    // Audio narration
    if (this.firstTimeToBassin) {
      if ($("#logbook .zone-selector").length > 0) {
        this.playNarration(this.data.content.zone_selector.audio)
      } else {
        this.playNarration(this.data.content.oops.audio)
      }
    }

    // Audio sound effects
    const activateZone1 = (this.currentVisitorData.records[`ST_LOGBOOK_01`] == "TRUE");
    const activateZone2 = (this.currentVisitorData.records[`ST_LOGBOOK_02`] == "TRUE");
    const activateZone3 = (this.currentVisitorData.records[`ST_LOGBOOK_03`] == "TRUE");
    const activateZone4 = (this.currentVisitorData.records[`ST_LOGBOOK_04`] == "TRUE");
    this.playBassinSounds(activateZone1, activateZone2, activateZone3, activateZone4)
  }

  animateScreen3() {

    // Stop current sounds
    this.stopCurrentNarration();
    this.stopBassinSounds();

    // Build animation timeline
    this.currentTimeline = gsap.timeline();
    this.currentTimeline.to($(`#logbook`), {
      x: -62,
      duration: 1,
    }, '<');
    this.currentTimeline.to($(`#logbook-page-1`), {
      rotation: 85,
      duration: 1,
      transformOrigin: "98px 98px"
    }, '<');
    this.currentTimeline.to($(`#logbook-page-2`), {
      rotation: 80,
      duration: 1,
      transformOrigin: "98px 98px"
    }, '<');
  }

  animateScreen4(playNarration = true) {

    // Stop current sounds
    this.stopCurrentNarration();
    this.stopBassinSounds();

    // Build animation timeline
    this.currentTimeline = gsap.timeline();
    this.currentTimeline.to($(`#logbook`), {
      x: -1450,
      duration: 1.5,
    }, '<');
    this.currentTimeline.to($(`#avatar`), {
      x: 500,
      autoAlpha: 0,
      duration: 1.5,
    }, '<');
    this.currentTimeline.to($(`#logbook-page-1, #logbook-page-2`), {
      rotation: 0,
      duration: 1.0,
      transformOrigin: "98px 98px"
    }, '<');
    this.currentTimeline.fromTo($(`.final-wrapper, .rfid-cta`, `#screen-4`), {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
      duration: 0.5,
    }, 0.75);

    this.currentTimeline.add(() => this.stopCurrentNarration())
    if (playNarration) this.currentTimeline.add(() => this.playNarration(this.data.content.final_screen.audio))
    this.currentTimeline.add(() => this.sendLedMessage())
  }

  animateScreen5() {
    this.animateScreen4(false);

    this.currentTimeline.fromTo($(`.final-wrapper, .rfid-cta, #outro-cta`, `#screen-5`), {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
      duration: 0.5,
    }, 0.75);
  }

  playBassinSounds(zone1, zone2, zone3, zone4) {

    console.log("playBassinSounds", zone1, zone2, zone3, zone4);

    [zone1, zone2, zone3, zone4].forEach((zoneActivated, index) => {
      if (this.bassinSounds[index] === undefined) {
        const file = this.data.content.zone_completed.zones[index].sound_effect;
        this.bassinSounds[index] = new Howl({
          src: [file],
          loop: true,
          autoplay: false,
          volume: this.settings.volume.bassin,
        });

        this.bassinSounds[index].on('fade', function (e) {
          if (this.volume() === 0) this.stop();
        });
      }

      if (zoneActivated) this.bassinSounds[index].volume(this.settings.volume.bassin).play();
    });
  }

  goToFinaleScreen() {

    // Stop current timeline
    this.clearCurrentTimeline();
    this.clearQuizTimeline();

    // Select screen depending on visitor progress
    if (this.visitorHasCompletedItAll()) {
      this.goToScreen(5)
    } else {
      this.goToScreen(4)
    }
  }

  stopBassinSounds() {
    [0, 1, 2, 3].forEach((index) => {
      if (this.bassinSounds[index] !== undefined && this.bassinSounds[index].volume() > 0) {
        this.bassinSounds[index].fade(this.bassinSounds[index].volume(), 0, 300)
      }
    })
  }

  async selectZone(zoneIndex) {
    this.currentZoneIndex = parseInt(zoneIndex);
    this.currentQuizData = await this.data.zones[zoneIndex].quiz.filter((el) => {
      const componentAges = el.age.split(",");
      const visitorAge = this.currentVisitorData.records["AGE"];
      return componentAges.includes(visitorAge.toString());
    });

    await this.renderQuiz(zoneIndex);

    // Select quiz component according to visitor data progress
    const componentsCount = $("#quiz .quiz-component").length;
    const currentVisitorProgress = this.currentVisitorData.records["ST_LOGBOOK_0" + (this.currentZoneIndex + 1)];
    if (!Number.isNaN(parseInt(currentVisitorProgress))) {
      const targetComponentIndex = Math.max(0, Math.min((parseInt(currentVisitorProgress) - 1), componentsCount));
      this.selectQuizComponent(targetComponentIndex);
    } else {
      this.selectQuizComponent(0);
    }

    // Highlight zone tab
    $(".logbook-menu .tab").css("z-index", "auto")
    $(`.logbook-menu #tab-${zoneIndex + 1}`).css("z-index", "1")

    // Go to screen 3
    this.goToScreen(3);
  }

  markZoneAsCompleted(zoneIndex) {
    console.log("markZoneAsCompleted", zoneIndex)
    $(`#logbook .zone[data-zone-id='${zoneIndex + 1}']`).eq(zoneIndex).addClass("completed");

    // Save to MQTT
    this.tagUpdateRecord("ST_LOGBOOK_0" + (this.currentZoneIndex + 1), "TRUE");

    // Update visitor content on screen
    this.tagSaveCurrentData();
    this.updateVisitorProgress();
    this.updateVisitorProgressScreen(zoneIndex + 1);

    this.clearQuizTimeline();
    this.currentQuizTimeline = new gsap.timeline()

    // Animate bassin image zone
    this.currentQuizTimeline.fromTo(`#bassin-image-wrapper .bassin-layer[data-zone-id='${this.currentZoneIndex + 1}']`, {
      alpha: 0
    }, {
      alpha: 1,
      duration: 1,
    }, 1.5)

    // Animate tooltip
    this.currentQuizTimeline.fromTo(`#bassin-image-wrapper .completed-tooltip[data-zone-id='${this.currentZoneIndex + 1}']`, {
      alpha: 0,
      y: -20,
    }, {
      alpha: 1,
      y: 0,
      duration: 0.5,
    })

    this.currentQuizTimeline.add(() => this.playNarration(this.data.content.zone_completed.zones[zoneIndex].audio))
  }

  selectQuizComponent(componentIndex) {

    this.quizStatus = QUIZ_ANIMATING;
    this.updateNextButtonState();

    this.clearQuizTimeline();
    this.currentQuizTimeline = new gsap.timeline()

    // Fade out
    this.currentQuizTimeline.to($("#quiz"), {
      alpha: 0,
      x: -40,
      duration: 0.3
    });

    // Update content
    this.currentQuizTimeline.add(() => {
      this.currentQuizComponentIndex = componentIndex;
      $("#quiz .quiz-component").removeClass("active");
      $("#quiz .quiz-component").eq(componentIndex).addClass("active");
      $("#quiz .quiz-component").eq(componentIndex).find(".options").addClass("active")
      this.updateNextButtonState();
    })

    // Fade in
    this.currentQuizTimeline.to($("#quiz"), {
      alpha: 1,
      x: 0,
      duration: 0.3
    });

    // Audio narration
    this.currentQuizTimeline.add(() => this.playNarration(this.currentQuizData[componentIndex].audio))

    // Update input status
    this.currentQuizTimeline.add(() => {
      this.quizStatus = QUIZ_USER_INPUT;
      this.updateNextButtonState();
    })
  }

  updateNextButtonState() {
    const isSelection = $("#quiz .quiz-component.active").data("type") === "selection";
    const isTrueFalse = $("#quiz .quiz-component.active").data("type") === "trueorfalse";
    const hasOption = $("#quiz .quiz-component.active .options .option.selected").length > 0;
    const disableConfirmSelection = ((isSelection || isTrueFalse) && !hasOption) || (this.quizStatus === QUIZ_ANIMATING);
    $("#quiz .quiz-component.active").find('.trigger.confirm-button, .trigger.next-button').toggleClass("disabled", disableConfirmSelection);
  }

  nextQuizComponent() {

    if (this.lockScreen) return;

    this.stopCurrentNarration()

    if (this.currentQuizComponentIndex + 1 < this.currentQuizData.length) {
      // There are still components to show
      this.selectQuizComponent(this.currentQuizComponentIndex + 1)

      // Save progress to MQTT
      if (this.currentQuizComponentIndex >= 1) {
        this.tagUpdateRecord("ST_LOGBOOK_0" + (this.currentZoneIndex + 1), (this.currentQuizComponentIndex + 1));
        this.tagSaveCurrentData();
      }

    } else {
      // We have reached the end
      this.markZoneAsCompleted(this.currentZoneIndex)
      this.firstTimeToBassin = false;
      this.goToScreen(2);
    }
  }

  toggleSelection(e) {
    if (this.quizStatus !== QUIZ_USER_INPUT) return;

    const currentQuizComponentAllowMultipleSelection = $(e.currentTarget).parents(".quiz-component").data("allow-multiple-selection");
    if (currentQuizComponentAllowMultipleSelection === false) {
      $(e.currentTarget).parents(".quiz-component").find(".option").removeClass("selected")
    }

    $(e.currentTarget).toggleClass("selected")
    this.updateNextButtonState();
  }

  confirmSelectionComponent() {
    let feedbackIsPositive = true;
    $(".quiz-component.active .options .option").each((i, n) => {
      const isValidOption = this.currentQuizData[this.currentQuizComponentIndex].options[i].is_valid_answer;
      if (isValidOption && !$(n).hasClass("selected")) {
        feedbackIsPositive = false;
      } else if (!isValidOption && $(n).hasClass("selected")) {
        feedbackIsPositive = false;
      }
    });

    // Show visual feedback
    this.showFeedback(feedbackIsPositive)

    // Audio narration
    const feedbackKey = feedbackIsPositive ? "positive" : "negative";
    this.playNarration(this.currentQuizData[this.currentQuizComponentIndex].feedbacks[feedbackKey].audio)
  }

  visitorHasCompletedItAll() {
    for (let i = 1; i <= 4; i++) {
      const hasCompletedLogbook = (this.currentVisitorData.records[`ST_LOGBOOK_0${i}`] == "TRUE");
      if (!hasCompletedLogbook) return false
    }
    return true;
  }

  visitorHasAvailableActivities() {
    for (let i = 1; i <= 4; i++) {
      const hasCompletedDiscovery = (this.currentVisitorData.records[`ST_DISCOVERY_0${i}`] == "TRUE");
      const hasCompletedLogbook = (this.currentVisitorData.records[`ST_LOGBOOK_0${i}`] == "TRUE");
      if (hasCompletedDiscovery && !hasCompletedLogbook) return true
    }
    return false;
  }

  showFeedback(feedbackIsPositive) {

    if (this.quizStatus === QUIZ_FEEDBACK) return;
    this.quizStatus = QUIZ_FEEDBACK;

    // Disable showFeedback button
    $(".quiz-component.active .button[data-action='confirmSelectionComponent']").addClass("clicked")

    $(".quiz-component.active .options").removeClass("active")
    $(".quiz-component.active .feedback-block").addClass("active")

    if (feedbackIsPositive) {
      console.log("Feedback is positive")
      $(".quiz-component.active .feedback.positive").addClass("active")
    } else {
      console.log("Feedback is BAADDD")
      $(".quiz-component.active .feedback.negative").addClass("active")
    }

    this.clearQuizTimeline();
    this.currentQuizTimeline = new gsap.timeline()

    // Fade in
    this.currentQuizTimeline.fromTo($(".quiz-component.active .feedback.active"), {
      alpha: 0,
      scale: 0.9
    }, {
      alpha: 1,
      scale: 1,
      x: 0,
      duration: 0.3
    });
  }

  updateVisitorProgress() {

    $(".icon .completed, .icon .in-progress, .icon .locked", "#logbook .logbook-menu .tab").removeClass("active")

    for (let i = 0; i < 4; i++) {
      const $tab = $("#logbook .logbook-menu .tab").eq(i);
      const $zoneElements = $(`#logbook-page-2 [data-zone-id='${i + 1}']`);

      $tab.find(".icon .completed, .icon .in-progress, .icon .locked").removeClass("active");
      $zoneElements.removeClass("completed started ready");

      if (this.currentVisitorData != null) {
        const hasCompletedDiscovery = (this.currentVisitorData.records[`ST_DISCOVERY_0${i + 1}`] == "TRUE");
        const hasCompletedLogbook = (this.currentVisitorData.records[`ST_LOGBOOK_0${i + 1}`] == "TRUE");
        const hasStartedLogbook = (this.currentVisitorData.records[`ST_LOGBOOK_0${i + 1}`] != "FALSE");

        if (hasCompletedLogbook) {
          $tab.find(".icon .completed").addClass("active");
          $zoneElements.addClass("completed");
        } else if (hasStartedLogbook) {
          $tab.find(".icon .in-progress").addClass("active");
          $zoneElements.addClass("started ready");
        } else if (hasCompletedDiscovery) {
          $tab.find(".icon .in-progress").addClass("active");
          $zoneElements.addClass("ready");
        } else {
          $tab.find(".icon .locked").addClass("active");
        }

      } else {
        $tab.find(".icon .locked").addClass("active");
      }
    }
  }

  updateVisitorProgressScreen(zoneId) {
    $("#logbook-page-2 #zone-selector-help").toggle(zoneId == false);
    $("#logbook-page-2 #zone-selector-zone1").toggle(zoneId === 1);
    $("#logbook-page-2 #zone-selector-zone2").toggle(zoneId === 2);
    $("#logbook-page-2 #zone-selector-zone3").toggle(zoneId === 3);
    $("#logbook-page-2 #zone-selector-zone4").toggle(zoneId === 4);

    // Show completed tooltip
    if (zoneId != false) {
      $(`#logbook-page-2 .completed-tooltip`).removeClass("active");
      $(`#logbook-page-2 .completed-tooltip[data-zone-id='${zoneId}']`).addClass("active");
    }
  }

  goToScreenSaver() {

    // Super constructor
    if (super.goToScreenSaver() == false) {
      return false;
    }
  }

  clearQuizTimeline() {
    if (this.currentQuizTimeline) {
      this.currentQuizTimeline.kill();
      this.currentQuizTimeline = null;
    }
  }

  clearCurrentTimeline() {
    if (this.currentTimeline) {
      this.currentTimeline.kill();
      this.currentTimeline = null;
    }
  }

  reset(screenId) {

    if (this.redirectTimeout != false) {
      clearTimeout(this.redirectTimeout);
      this.redirectTimeout = false;
    }

    this.clearCurrentTimeline();
    this.clearQuizTimeline();

    let resetCallback = () => {
      // TODO Add things to append after reset here, if required
      this.clearTheme();
      this.avatar.setAvatar(null);
      $(".quiz-component.active .button").removeClass("clicked")
      $(".quiz-component.active .feedback").removeClass("active")
      $(".quiz-component.active .feedback-block").removeClass("active")
      gsap.set($(`#avatar`), {x: 0});
      this.updateVisitorProgress()
    }

    // TODO Reset other things here
    gsap.to($(`#avatar`), {
      autoAlpha: 0,
      x: 62 * 0.75,
      duration: 0.5 * 0.75,
    });
    this.firstTimeToBassin = true;
    this.animateScreen1();
    this.stopBassinSounds();

    if (typeof screenId == "undefined") {
      resetCallback();
    }

    // Super
    if (super.reset(screenId, resetCallback) == false) {
      return false;
    }

  }
}
